import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export const Navigation = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <nav className="bg-gray-800 py-4 px-6 mb-8 rounded-lg">
      <div className="flex justify-between items-center">
        <div className="hidden md:flex md:space-x-6">
          <Link
            to="/"
            className={`text-sm font-medium ${
              isActive("/") ? "text-white" : "text-gray-300 hover:text-white"
            }`}
          >
            Поиск сделок
          </Link>
          <Link
            to="/reports"
            className={`text-sm font-medium ${
              isActive("/reports")
                ? "text-white"
                : "text-gray-300 hover:text-white"
            }`}
          >
            Отчеты
          </Link>

          {/* <Link
            to="/dashboard"
            className={`text-sm font-medium ${
              isActive("/dashboard") ? "text-white" : "text-gray-300 hover:text-white"
            }`}
          >
            Дашборд
          </Link> */}
          <Link
            to="/datalens"
            className={`text-sm font-medium ${
              isActive("/datalens") ? "text-white" : "text-gray-300 hover:text-white"
            }`}
          >
            Даталенс
          </Link>
          {isAdminPage && (
            <>
              <Link
                to="/admin/register-clinic"
                className={`text-sm font-medium ${
                  isActive("/admin/register-clinic") ? "text-white" : "text-gray-300 hover:text-white"
                }`}
              >
                Регистрация
              </Link>
              <Link
                to="/admin/manage-clinic"
                className={`text-sm font-medium ${
                  isActive("/admin/manage-clinic") ? "text-white" : "text-gray-300 hover:text-white"
                }`}
              >
                Управление
              </Link>
              <Link
                to="/admin/work-schedule"
                className={`text-sm font-medium ${
                  isActive("/admin/work-schedule") ? "text-white" : "text-gray-300 hover:text-white"
                }`}
              >
                График работы
              </Link>
            </>
          )}
        </div>

        {/* Mobile menu button */}
        <div className="md:hidden">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-white focus:outline-none"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Desktop right menu
        <div className="hidden md:flex md:items-center md:space-x-4">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors ${
              isActive('/') 
                ? 'text-white' 
                : 'text-gray-300 hover:text-white'
            }`}
          >
            Поиск по сделкам
          </Link>

          <Link
            to="/refresh-token"
            className={`text-sm font-medium transition-colors ${
              isActive('/refresh-token') 
                ? 'text-white' 
                : 'text-gray-300 hover:text-white'
            }`}
          >
            Обновление токена
          </Link>
          <button className="gradient-button ml-4">
            Get Started
          </button>
        </div> */}

        {/* Mobile menu */}
        <div
          className={`md:hidden ${
            isMenuOpen ? "block" : "hidden"
          } absolute top-16 right-4 w-48 rounded-md shadow-lg bg-gray-800 z-50`}
        >
          <div className="py-1">
            <Link
              to="/"
              className={`block px-4 py-2 text-sm font-medium ${
                isActive("/") ? "text-white" : "text-gray-300 hover:text-white"
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Поиск сделок
            </Link>
            <Link
              to="/reports"
              className={`block px-4 py-2 text-sm font-medium ${
                isActive("/reports")
                  ? "text-white"
                  : "text-gray-300 hover:text-white"
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Отчеты
            </Link>

            {/* <Link
              to="/dashboard"
              className={`block px-4 py-2 text-sm font-medium ${
                isActive("/dashboard")
                  ? "text-white"
                  : "text-gray-300 hover:text-white"
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Дашборд
            </Link> */}
            <Link
              to="/datalens"
              className={`block px-4 py-2 text-sm font-medium ${
                isActive("/datalens")
                  ? "text-white"
                  : "text-gray-300 hover:text-white"
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Даталенс
            </Link>
            {isAdminPage && (
              <>
                <Link
                  to="/admin/register-clinic"
                  className={`block px-4 py-2 text-sm font-medium ${
                    isActive("/admin/register-clinic") ? "text-white" : "text-gray-300 hover:text-white"
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Регистрация
                </Link>
                <Link
                  to="/admin/manage-clinic"
                  className={`block px-4 py-2 text-sm font-medium ${
                    isActive("/admin/manage-clinic") ? "text-white" : "text-gray-300 hover:text-white"
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Управление
                </Link>
                <Link
                  to="/admin/work-schedule"
                  className={`block px-4 py-2 text-sm font-medium ${
                    isActive("/admin/work-schedule") ? "text-white" : "text-gray-300 hover:text-white"
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  График работы
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
